const waiverReasons = {
  CONTRACTUAL: { label: 'msg_codes_contractual', value: 'CONTRACTUAL' },
  BUSINESS_APPROVED: { label: 'msg_codes_gpdr_business_overrule', value: 'BUSINESS_APPROVED' },
};

export default waiverReasons;
